(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("groupResource", ["$resource", groupResource]);
    function groupResource($resource) {
        return $resource("/api/groups/:groupId", {}, {
            update: {
                method: "PUT",
                params: { groupId: "@groupId" }
            },
            reorderGroup: {
                method: "PUT"
            }
        });
    }
}());
